import { render, staticRenderFns } from "./DetailsPageTitle.vue?vue&type=template&id=5b0667aa&scoped=true"
import script from "./DetailsPageTitle.vue?vue&type=script&lang=js"
export * from "./DetailsPageTitle.vue?vue&type=script&lang=js"
import style0 from "./DetailsPageTitle.vue?vue&type=style&index=0&id=5b0667aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0667aa",
  null
  
)

export default component.exports